import { PulseMonthlySummaries, PulseSentimentDirection } from '../pulse-types';

export const citationIdsForDirection = (
  summaries: PulseMonthlySummaries | undefined,
  direction: PulseSentimentDirection
): string[] => {
  if (!summaries) {
    return [];
  }

  const citations =
    direction === 'all'
      ? [...summaries.tailwind.citations, ...summaries.headwind.citations]
      : summaries[direction].citations;

  return [
    ...new Set(
      citations
        .map(citation => citation.kg_insight_id)
        .filter((insightId): insightId is string => insightId !== undefined)
    ),
  ];
};

export const citationIdsByTypeForDirection = (
  summaries: PulseMonthlySummaries | undefined,
  direction: PulseSentimentDirection
): { kgInsightIds: string[]; scenarioInsightIds: string[] } => {
  if (!summaries) {
    return { kgInsightIds: [], scenarioInsightIds: [] };
  }

  const citations =
    direction === 'all'
      ? [...summaries.tailwind.citations, ...summaries.headwind.citations]
      : summaries[direction].citations;

  const scenarioInsightIds = [
    ...new Set(
      citations
        .map(citation => citation.scenario_insight_id)
        .filter((insightId): insightId is string => insightId !== undefined)
    ),
  ];

  return {
    kgInsightIds: citationIdsForDirection(summaries, direction),
    scenarioInsightIds,
  };
};

export const pinnedInsightIdsByTypeForDirection = (
  summaries: PulseMonthlySummaries | undefined,
  direction: PulseSentimentDirection
): { kgInsightIds: string[]; scenarioInsightIds: string[] } => {
  const citationIds = citationIdsByTypeForDirection(summaries, direction);

  if (!summaries) {
    return citationIds;
  }

  return {
    kgInsightIds: citationIds.kgInsightIds,
    scenarioInsightIds: citationIds.scenarioInsightIds,
  };
};
